__turbopack_context__.v({
  "callButton": "FloatingBookVisitCTA-module__43ZLEW__callButton",
  "copiedLive": "FloatingBookVisitCTA-module__43ZLEW__copiedLive",
  "phoneNumberButton": "FloatingBookVisitCTA-module__43ZLEW__phoneNumberButton",
  "wrapper": "FloatingBookVisitCTA-module__43ZLEW__wrapper",
});
